import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { ensureClickaduLoader, appendClickaduSpot } from './clickaduLoader'

class ClickaduBanner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      bannerId: undefined,
      renderable: false
    }
  }

  componentDidMount() {
    this.injectScript()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState(
        {
          renderable: false
        },
        () => {
          this.setState(
            {
              renderable: true
            },
            () => {
              this.injectScript()
            }
          )
        }
      )
    }
  }

  injectScript() {
    const { size, position } = this.props

    const ids300x100 = {
      top: [2050680]
    }
    const ids300x250 = {
      top: [2050674],
      center: [2050676],
      bottom: [2050678]
    }
    const banners = {
      '300x100': {
        top: ids300x250.top.map(id => {
          return id
        }),
        default: 2050680
      },
      '300x250': {
        top: ids300x250.top.map(id => {
          return id
        }),
        center: ids300x250.center.map(id => {
          return id
        }),
        center2: ids300x250.center.map(id => {
          return id
        }),
        bottom: ids300x250.bottom.map(id => {
          return id
        }),
        reader: ids300x250.top.map(id => {
          return id
        }),
        reader_center: ids300x250.center.map(id => {
          return id
        }),
        reader_bottom: ids300x250.bottom.map(id => {
          return id
        }),
        default: 2050682
      }
    }

    banners['728x90'] = banners['300x250']
    banners['728x90'].top = [ids300x100.top[0]]

    let banner
    switch (size) {
      case '300x100':
        banner =
          (banners['300x100'][position] || [])[0] || banners['300x100'].default
        break
      case '728x90':
      case '300x250':
        banner =
          (banners['300x250'][position] || [])[0] || banners['300x250'].default
        break
      default:
        return
    }

    this.setState(
      {
        renderable: true,
        bannerId: banner
      },
      () => {
        const { bannerId } = this.state
        if (this.container) {
          ensureClickaduLoader()
          appendClickaduSpot(this.container, bannerId)
        }
      }
    )
  }

  render() {
    const { bannerId, renderable } = this.state
    if (!renderable || !bannerId) {
      return ''
    }

    return (
      <div
        className="text-center"
        data-id={bannerId}
        ref={e => {
          this.container = e
        }}
      />
    )
  }
}

export default withRouter(ClickaduBanner)
